const DEFAULT_API_ORIGIN = 'http://localhost:3000';

// VITE_API_URL is the server address WITHOUT "/api". A trailing "/api" or "/" is
// tolerated so older env values keep working.
export function normalizeApiOrigin(raw: string | undefined): string {
  return (raw || DEFAULT_API_ORIGIN).replace(/\/+$/, '').replace(/\/api$/, '');
}

export const API_ORIGIN = normalizeApiOrigin(import.meta.env.VITE_API_URL);
export const API_BASE = `${API_ORIGIN}/api`;
export const WS_ORIGIN = API_ORIGIN.replace(/^http/, 'ws');
